const configuration = {

    /*-----------------------------IMAGES------------------------------------------*/
    //General Logos
    mobileSmallLogo: '/assets/images/Logos/topotradeSmallLogo.png',
    mediumLogo: '/assets/images/Logos/topotradeMediumLogo.png',
    footerLogo: '/assets/images/Logos/footer-logo.png',
    desktopLogo: '/assets/images/Logos/LOTG-Logo1.png',
    menuArrow: '/assets/icons/icon_arrow_menu.png',

    //Social Media
    facebookDark: "/assets/icons/fb_icon_sticky.svg",
    instagramDark: "/assets/icons/insta_icon_sticky.svg",
    linkedinDark: "/assets/icons/Linkedin_icon_sticky.svg",
    twitterDark: "/assets/icons/twitter_icon_sticky.svg",
    youtubeDark: "/assets/icons/youtube_icon_sticky.svg",
    eBayDark: "/assets/icons/ebay_icon_sticky.svg",
    whatsapp: "/assets/icons/whatsapp_icon.png",
    whats_icon: "/assets/images/whats_icon.png",
    whatsapp_channel: "/assets/icons/whatsapp_channel.png",
    

    // facebookLight: "/assets/icons/fb_icon_sticky copy.png",
    // instagramLight: "/assets/icons/insta_icon_sticky copy.png",
    // linkedinLight: "/assets/icons/Linkedin_icon_sticky copy.png",
    // twitterLight: "/assets/icons/twitter_icon_sticky copy.png",
    // youtubeLight: "/assets/icons/youtube_icon_sticky copy.png",
    // eBayLight: "/assets/icons/eBay_icon_sticky copy.png",

    //Header Icons
    headerUserIcon: 'pi pi-user',
    headerNotificationsIcon: 'pi pi-inbox',
    headerWatchlistIcon: 'pi pi-star',
    headerCartIcon: '/assets/icons/cart_icon_header.png',


    //Brands Logos
    brandsLogosDirectory: '/assets/brands/',
    brandsLogosExtension: '.png',

    //Home Images
    banner: "/assets/images/landing/banner-leftside-logo.png",
    bannerAnimation: "/assets/icons/banner-animation-1.gif",
    visaPaymentMethodLogo: '/assets/images/payments-Methode/Visa.png',
    masterCardPaymentMethodLogo: '/assets/images/payments-Methode/masterCart.png',
    payPalPaymentMethodLogo: '/assets/images/payments-Methode/paypal.png',
    registerSellerLogo: '/assets/images/landing/services/register-sellers.png',
    certifiedInspectionLogo: '/assets/images/landing/services/certified-inspection.png',
    worldWideDeliveryLogo: "/assets/images/landing/services/worldwide-delivery.png",

    //About Us Images
    AboutUsImage12 :"/assets/images/about-us/coll_watches_img.png",
    AboutUsImage:"/assets/images/about-us/aboutt_us_image.png",
    AboutUsImage1: "/assets/images/about-us/05.png",
    AboutUsImage2: "/assets/images/about-us/02.png",
    AboutUsImage3: "/assets/images/about-us/08.png",
    AboutUsImage4: "/assets/images/about-us/07.png",
    AboutUsImage5: "/assets/images/about-us/01.png",
    AboutUsImage6: "/assets/images/about-us/03.png",
    AboutUsImage7: "/assets/images/about-us/06.png",
    AboutUsImage8: "/assets/images/about-us/04.png",
    AboutUsImage9: "/assets/images/about-us/09.png",
    AboutUsImage10: "/assets/images/about-us/10.png",
    AboutUsImage11: "/assets/images/about-us/ourstory.png",
    AboutUsVideo: "https://www.youtube.com/embed/rNkHGOOFw0M",
    checkMark: "/assets/images/about-us/check.png",
    briefCaseIcon: '/assets/images/about-us/briefcase.png',
    lifeBoyIcon: '/assets/images/about-us/lifebuoy.png',
    toolIcon: '/assets/images/about-us/tool.png',
    qgImage: '/assets/images/about-us/qgimage.png',
    serviceImage: '/assets/images/about-us/image.png',

    AboutUsContainer1: '/assets/images/about-us/pngwing5.png',
    AboutUsContainer2: '/assets/images/about-us/secure_payment_icon_white.png',
    AboutUsContainer3: '/assets/images/about-us/pngwing1.png',
    AboutUsContainer41: '/assets/images/about-us/pngwing6.png',
    AboutUsContainer42: '/assets/images/about-us/worldwide_delivery_icon_white.png',
    AboutUsContainer5: '/assets/images/about-us/pngwing7.png',
    AboutUsContainer6: '/assets/images/about-us/pngwin8.png',
    AboutUsContainer7: '/assets/images/about-us/aboutus_coins_img.png',
    AboutUsContainer81: '/assets/images/about-us/pngwing4.png',
    AboutUsContainer82: '/assets/images/about-us/pngwing2.png',

    inkdin:'/assets/images/about-us/Linkedin_icon_footer.svg',
    founder2: '/assets/images/about-us/founder_Majd_Aboulhosn.png',
    founder1: '/assets/images/about-us/founder_Ramzi_Traboulsi.png',
    founder3: '/assets/images/about-us/founder_Nathalie_Mamo.png',
    founder4: '/assets/images/about-us/founder_Zein_Rachidi.png',
    OurApproach1: '/assets/images/about-us/trusted_sellers_icon.png',
    OurApproach2: '/assets/images/about-us/ownership_proof_icon.png',
    OurApproach3: '/assets/images/about-us/serial_number_icon.png',
    Quality1: '/assets/images/about-us/article_number_icon.png',
    Quality2: '/assets/images/about-us/accessory_inventory_icon.png',
    Quality3: '/assets/images/about-us/functionality_icon.png',
    Quality4: '/assets/images/about-us/cleaning_packaging_icon.png',
    //Help/FAQ Images
    askQuestionBanner: '/assets/images/faq/ask-question-bg.png',
    askQuestionBannerMobile: '/assets/images/faq/ask-question-mob.png',
    phoneIcon: '/assets/icons/phone.png',
    atSignIcon: '/assets/icons/at-sign.png',
    chatIcon: '/assets/icons/circle.png',

    //ContactUs Images
    contactUsChatIcon: '/assets/images/contact-us/icon_contact_livechat.png',
    contactUsPhoneIcon: '/assets/images/contact-us/icon_contact_phone.png',
    contactUsMailIcon: '/assets/images/contact-us/icon_contact_email.png',
    contactUsEditIcon: '/assets/images/contact-us/icon_contact_address.png',

    //Currencies and Language Images
    flagsDirectory: '/assets/icons/flags/',
    flagsExtension: '.png',
    languageDropdownArrow: '/assets/icons/arrow-down.svg',

    //Dashboard Images
    userIcon: 'pi pi-user',
    MyListingsIcon: 'pi pi-bars',
    inboxIcon: 'pi pi-inbox',
    notificationsIcon: 'pi pi-bell',
    watchlistIcon: 'pi pi-star',
    ordersIcon: 'pi pi-shopping-cart',
    dashboardmyListings: '/assets/icons/icon_listings_dashboard.png',
    dashboardmyOrders: '/assets/icons/icon_orders_dashboard.png',
    dashboardmyFavorites: '/assets/icons/icon_favorites_dashboard.png',
    dashboardSettings: '/assets/icons/icon_settings_dashboard.png',
    dashboardLogout: '/assets/icons/icon_logout_dashboard.png',
    dashboardNotification: '/assets/icons/icon_notifications_dashboard.png',
    dashboardProfileIcon: '/assets/icons/icon_profile_dashboard.png',
    dashboardMessageCenter: '/assets/icons/icon_inbox_dashboard.png',
    dashboardOffers: '/assets/icons/icon_offers_dashboard.png',
    noFavorites: '/assets/images/icon_no_favorites.svg',
    noMessages:'/assets/images/icon_no_messages.svg',
    noListings:'/assets/images/icon_no_listings.svg',
    noNotifications:'/assets/images/dashboard/icon_no_notifications@2x.png',
    noOrders:'/assets/images/dashboard/icon_no_orders@2x.png',
    noSettings:'/assets/images/dashboard/icon_no_settings@2x.png',
    settings:'/assets/images/dashboard/icon_settings_dashboard_on.svg',
    notificationIsSeen: '/assets/images/icon_read.png',
    

    //My Listings Table
    myListingsEditIcon: 'pi pi-pencil',
    myListingsDuplicateIcon: 'pi pi-copy',
    myListingsDeleteIcon: 'pi pi-trash',
    myListingsCreateIcon: 'pi pi-plus',

    //Kit Table Images
    itemEditIcon: 'pi pi-pencil',
    itemSetAsMain: 'pi pi-star-o',
    itemDuplicate: 'pi pi-clone',
    itemDelete: 'pi pi-trash',

    //product
    cartIconProduct: '/assets/icons/cart_icon_product.svg',
    favoritesIconProduct: '/assets/icons/favorites_icon_product.png',
    shareIconProduct: '/assets/images/share_icon_details.svg',
    favoriteIconProduct: '/assets/images/favorites_icon_details.svg',

    //product details Images
    favoriteSmallOrange: '/assets/icons/favorites_icon_small_orange.svg',
    viewsSmallOrange: '/assets/icons/views_icon_small_orange.svg',
    certifiedSeller: '/assets/images/certified_seller.png',
    trustedSeller2: '/assets/images/trusted_seller2.png',
   
    moneyBack: '/assets/images/money_back.png',

    //rfp
    rfpSuccessImage: '/assets/icons/icon_success.svg',
    iconCalender: '/assets/images/icon_date_input.png',

    //sell
    closeIcon: '/assets/icons/icon_close.png',
    addIcon: '/assets/icons/icon_add.png',
    iconListCheck: '/assets/images/icon_list_check.png',
    iconAlert: '/assets/images/icon_alert.png',
    iconCloseMenu: '/assets/images/icon_menu_close.svg',
    iconMenu: '/assets/images/icon_menu.svg',

    //kits
    kitFavorites: '/assets/icons/favorites_icon_product.svg',
    kitCart: '/assets/icons/cart_icon_product.svg',


    //become a Partner Images
    BecomePartner1: '/assets/images/become-partner/partner_img_1.svg',
    BecomePartner2: '/assets/images/become-partner/partner_img_2.svg',
    BecomePartner3: '/assets/images/become-partner/partner_img_3.svg',

    //checkout
    radioButtonIcon: 'assets/icons/icon_list_check.png',
}

export default configuration 